import React, { Component } from 'react'
import {
  StyledTableBody,
  StyledTable,
  ContainerBody,
  LoadingContainer,
  ContainerGifLoading,
  TableEmptyTd
} from './styled';
import icons from '../treatedIcons';

const { LoadingCircle } = icons;

class CustomTable extends Component {
  static defaultProps = {
    loading: false,
    maxSize: 'default',
    striped: true
  }

  tableRef = React.createRef();

  componentDidMount() {
    this.applyCellTitles();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.lines !== this.props.lines ||
      prevProps.loading !== this.props.loading
    ) {
      this.applyCellTitles();
    }
  }

  applyCellTitles = () => {
    const table = this.tableRef.current;
    if (!table) return;

    const cells = table.querySelectorAll('th, td');
    cells.forEach(cell => {
      if (cell.classList.contains('fc-table-empty-td')) return;
      if (cell.querySelector('input, textarea, select, button')) return;

      const text = (cell.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      const isOverflowing = cell.scrollWidth > cell.clientWidth;
      const canAutoSetTitle = !cell.hasAttribute('title') || cell.dataset.autoTitle === 'true';

      if (isOverflowing && canAutoSetTitle) {
        cell.setAttribute('title', text);
        cell.dataset.autoTitle = 'true';
      } else if (!isOverflowing && cell.dataset.autoTitle === 'true') {
        cell.removeAttribute('title');
        delete cell.dataset.autoTitle;
      }
    });
  }
  
  mapLines = () => {
    const { lines } = this.props;
    if (Array.isArray(lines) && lines.length > 0) {
      const mappedLines = this.props.lines.map(this.props.renderLine);


      return mappedLines;
    }
    return null;
  }

  render() {
    const itemsQuantity = (Array.isArray(this.props.lines) && this.props.lines.length) || 0;
    return(
      <ContainerBody loading={this.props.loading}>
      {this.props.loading &&
              <LoadingContainer>
                <ContainerGifLoading>
                  <LoadingCircle />
                </ContainerGifLoading>
              </LoadingContainer>
            }
      <StyledTable
        ref={this.tableRef}
        striped={this.props.striped}
        responsive
        maxSize={this.props.maxSize}
        items={itemsQuantity}
      >
        <thead>
          {this.props.renderHeader()}
        </thead>
        <StyledTableBody loading={this.props.loading}>
          {this.mapLines() ? (
            this.mapLines()
          ) : (
            <tr>
              <TableEmptyTd colSpan={999} className="fc-table-empty-td">
                Não há registros nessa lista!
              </TableEmptyTd>
            </tr>
          )}
        </StyledTableBody>
      </StyledTable>
      </ContainerBody>
    );
  }
}

export default CustomTable;
